import type {
  SwiftIdApplicantAjax,
  SwiftIdApplicantCreateResultAjax,
  SwiftIdApplicantDataAjax,
} from './swift-id-applicant.backend-model';
import type { SwiftIdApplicantProfile } from './swift-id-applicant.model';
import { convertBooleanToString } from '../swift-id-application/swift-id-application.transformer';

export function transformSwiftIdApplicantCreate(
  item: SwiftIdApplicantCreateResultAjax,
  applicantData: Omit<SwiftIdApplicantProfile, 'id' | 'userId'>,
): SwiftIdApplicantProfile {
  return {
    ...applicantData,
    id: item.id,
  };
}

export function transformSwiftIdApplicantGet(
  item: SwiftIdApplicantAjax,
): SwiftIdApplicantProfile {
  return {
    ...item,
  };
}

/**
 * Converts applicant data with boolean values to PHP-compatible format (booleans as strings)
 */
export function convertBooleansToStrings(
  applicant: Record<string, any>,
): SwiftIdApplicantDataAjax {
  return convertBooleanToString(applicant) as SwiftIdApplicantDataAjax;
}
